import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IdCardLanyard } from 'lucide-react';
import { useStaffStore } from '../../stores/appStaffStore';
import { ALL_RESTAURANTS_ID, useAppUserDefaultStore } from '../../stores/appUserDefaultStore';
import { useLoadStaff } from '../../utils/dataLoadingUtils';

const StaffIcon: React.FC = () => {
  const { t } = useTranslation();
  const staff = useStaffStore(s => s.staff);
  const isDataLoaded = useStaffStore(s => s.isDataLoaded);
  const pendingStaffCount = useStaffStore(s => s.getPendingCount());
  const restaurant = useAppUserDefaultStore(s => s.restaurant);

  useLoadStaff();

  const staffCount = !restaurant || restaurant.id === ALL_RESTAURANTS_ID
    ? staff.length
    : staff.filter(member => member.restaurant_ids.includes(restaurant.id)).length;

  return (
    <NavLink
      to="/staff"
      title={t('nav.staff')}
      className={({ isActive }) => `flex shrink-0 items-center gap-2 px-3 py-2 rounded-xl border text-sm font-medium whitespace-nowrap
        text-secondary dark:text-secondary-dark hover:bg-cardLightGreen/80 dark:hover:bg-cardLightGreen-dark/80
        transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-darkGreenColor dark:focus-visible:ring-darkGreenColor-dark focus-visible:ring-offset-2 dark:focus-visible:ring-offset-background-dark
        ${isActive ? 'border-darkGreenColor dark:border-darkGreenColor-dark bg-cardLightGreen dark:bg-cardLightGreen-dark' : 'border-borderGrey dark:border-borderGrey-dark bg-background dark:bg-background-dark'}`}
    >
      <IdCardLanyard className="w-5 h-5 text-tertiary dark:text-tertiary-dark" />
      {t('nav.staffShort')}
      {isDataLoaded && (
        <span
          title={t('staff.staffCount', { count: staffCount })}
          className="rounded-lg bg-gray-100 dark:bg-gray-800 text-muted dark:text-muted-dark px-2 py-0.5 text-xs tabular-nums"
        >
          {staffCount}
        </span>
      )}
      {pendingStaffCount > 0 && (
        <span
          aria-label={`${t('staff.accessRequest.pending')}: ${pendingStaffCount}`}
          title={t('staff.accessRequest.pending')}
          className="rounded-lg bg-darkGreenColor dark:bg-darkGreenColor-dark text-white dark:text-white px-2 py-0.5 text-xs font-bold tabular-nums"
        >
          {pendingStaffCount}
        </span>
      )}
    </NavLink>
  );
};

export default StaffIcon;
